/* Vyra theme — minimal interactivity */

(function () {
  'use strict';

  // Gallery thumb swap
  document.querySelectorAll('.hero-product').forEach(function (hero) {
    var mainImg = hero.querySelector('.hero-product__media img');
    var thumbs = hero.querySelectorAll('.hero-product__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs[0].setAttribute('aria-current', 'true');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (src) mainImg.setAttribute('src', src);
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Cart count live update (basic)
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('.hero-product__form')) return;
    // Let Shopify handle submit; optionally intercept for ajax later.
  });

  // Lazy-load fluid blob animation only if not reduced-motion
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    document.querySelectorAll('.fluid-blob').forEach(function (b) { b.style.animation = 'none'; });
  }
})();
